export const NAV_FETCH = 'nav/FETCH';
export const NAV_RECEIVED = 'nav/RECEIVED';
export const NAV_ERROR = 'nav/ERROR';

export const TEAMS_API_TITLE = 'Teams';
export const TEAMS_NAV_PATH = 'primary';
export const TEAMS_NAV_KEY = 'TEAMS';



// WEBPACK FOOTER //
// ./src/store/actions/nav.types.js